<template>
  <div>
    <el-form
      ref="user"
      v-loading="loading"
      label-width="100px"
      :model="user"
      :rules="rules"
    >
      <el-form-item label="姓名" prop="fullName">
        <el-input v-model="user.fullName" />
      </el-form-item>
      <el-form-item label="用户名" prop="userName">
        <!-- <el-input v-model="user.userName" disabled="true" /> -->
        {{ user.userName }}
      </el-form-item>
      <el-form-item label="密码">
        <el-button
          type="primary"
          @click="dialogPasswordFormVisible = true"
        >更换密码</el-button>
      </el-form-item>
      <!-- <el-form-item label="性别" prop="sexId">
        <el-radio-group v-model="user.userInfo.sexId">
          <el-radio
            v-for="item in sex"
            :key="item.value"
            :label="item.value"
          >{{ item.text }}
          </el-radio>
        </el-radio-group>
      </el-form-item> -->
      <el-form-item label="手机" prop="phoneNumber">
        <el-input v-model="user.phoneNumber" />
      </el-form-item>
      <el-form-item label="邮箱" prop="email">
        <el-input v-model="user.email" />
      </el-form-item>
      <el-form-item label="单位" prop="companyId">
        <!-- {{ $store.getters["cache/getCompanyName"](user.userInfo.companyId) }} -->
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit">更新</el-button>
      </el-form-item>
    </el-form>

    <!-- 设置密码对话框 -->
    <el-dialog
      title="更换密码"
      :visible.sync="dialogPasswordFormVisible"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-row type="flex" justify="center">
        <el-col :sm="24" :lg="18">
          <el-form
            ref="passwordForm"
            :rules="passwordRules"
            :model="passwordForm"
            label-position="left"
            label-width="100px"
          >
            <el-form-item label="原密码" prop="oldPassword">
              <el-input v-model="passwordForm.oldPassword" show-password />
            </el-form-item>
            <el-form-item label="新密码" prop="newPassword">
              <el-input v-model="passwordForm.newPassword" show-password />
            </el-form-item>
            <el-form-item label="确认新密码" prop="confirmPassword">
              <el-input v-model="passwordForm.confirmPassword" show-password />
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogPasswordFormVisible = false">
          取消
        </el-button>
        <el-button type="primary" @click="updatePassword">
          确认
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { usersService } from '@/api/users'

export default {
  props: {
    user: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    const validatePhoneNumber = (rule, value, callback) => {
      if (value !== '') {
        // this.$message({
        //   message: rule.field + '为必传项',
        //   type: 'error'
        // })
        var pattern = /^1[3456789]\d{9}$/
        if (!pattern.test(value)) {
          callback(new Error('手机号码格式错误，请填写正确手机号码'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    const validateEmail = (rule, value, callback) => {
      if (value !== '') {
        // this.$message({
        //   message: rule.field + '为必传项',
        //   type: 'error'
        // })
        console.log(rule)
        var pattern = /^[0-9a-zA-Z_.-]+[@][0-9a-zA-Z_.-]+([.][a-zA-Z]+){1,2}$/
        if (!pattern.test(value)) {
          callback(new Error('邮箱格式错误，请填写正确邮箱'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    const validateConfirmPassword = (rule, value, callback) => {
      if (this.passwordForm.newPassword !== value) {
        callback(new Error('密码不一致'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      dialogPasswordFormVisible: false,
      passwordRules: {
        oldPassword: [
          { required: true, message: '请填写原密码', trigger: 'change' }
        ],
        newPassword: [
          { required: true, message: '请填写新密码', trigger: 'change' }
        ],
        confirmPassword: [
          {
            required: true,
            validator: validateConfirmPassword,
            trigger: 'change'
          }
        ]
      },
      rules: {
        phoneNumber: [{ validator: validatePhoneNumber, trigger: 'change' }],
        email: [{ validator: validateEmail, trigger: 'change' }]
      }
    }
  },
  computed: {
    // sex() {
    //   return this.$store.getters['dictionary/getDictionary']('sex')
    // }
  },
  methods: {
    resetPasswordForm() {
      this.$refs['passwordForm'].resetFields()
    },
    updatePassword() {
      this.$refs.passwordForm.validate((valid) => {
        if (valid) {
          usersService
            .changePassword({
              userId: this.user.id,
              oldPassword: this.passwordForm.oldPassword,
              newPassword: this.passwordForm.newPassword
            })
            .then((res) => {
              if (res.data === true) {
                // 重置
                this.resetPasswordForm()
                // 关闭弹窗
                this.dialogPasswordFormVisible = false
                this.$message({
                  message: '更换密码成功',
                  type: 'success',
                  duration: 5 * 1000
                })
              } else {
                this.$message({
                  message: `${res.data[0]?.description}`,
                  type: 'error',
                  duration: 5 * 1000
                })
              }
            })
        }
      })
    },
    submit() {
      this.$refs.user.validate((valid) => {
        console.log(valid)
        if (valid) {
          this.loading = true
          usersService.updateUser(this.user.id, this.user).then(() => {
            this.$notify({
              title: '成功',
              message: '更新成功',
              type: 'success',
              duration: 2000
            })
            this.loading = false
          }).catch(() => {
            this.loading = false
          })
        } else {
          console.log('error submit!!')
          this.$notify.error({
            title: '错误',
            message: `${
              !this.isEdit ? '新增' : '编辑'
            }用户失败,请检查数据是否合法!`
          })
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@media (min-width: 767px) {
  .el-dialog {
    width: 100%;
  }
}
</style>
